// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { FAKE_DATA } from '@services/constant';
import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getPagesData: [],
  getPagesDataSuccess: ['payload'],
  getPagesDataFailure: [],

  updateData: ['method', 'url', 'params', 'field', 'callback'],
  updateDataSuccess: ['payload'],
  updateDataFailure: [],

  getPageDetail: ['params'],
  getPageDetailSuccess: ['payload'],
  getPageDetailFailure: [],

  deleteData: ['id', 'url', 'field', 'callback'],
  deleteDataSuccess: ['payload'],
  deleteDataFailure: [],

  sendEmail: ['params', 'callback'],
  sendEmailSuccess: ['payload'],
  sendEmailFailure: [],

  uploadImageToAlbum: ['params', 'callback'],
  uploadImageToAlbumSuccess: ['payload'],
  uploadImageToAlbumFailure: [],

  deleteImageFromAlbum: ['params', 'callback'],
  deleteImageFromAlbumSuccess: ['payload'],
  deleteImageFromAlbumFailure: [],
});

export const INITIAL_STATE = Immutable({
  homePage: FAKE_DATA.homePage,
  aboutUs: FAKE_DATA.aboutUs,
  ownerInfo: FAKE_DATA.ownerInfo,
  contactUs: FAKE_DATA.contactUs,
  rooms: FAKE_DATA.rooms || [],
  roomDetail: FAKE_DATA.roomDetail || {},
  services: FAKE_DATA.services || [],
  serviceDetail: FAKE_DATA.serviceDetail || {},
  offers: FAKE_DATA.offers || [],
  offerDetail: FAKE_DATA.offerDetail || {},
  destinations: FAKE_DATA.destinations || [],
  destinationDetail: FAKE_DATA.destinationDetail || {},
  spas: FAKE_DATA.spas || [],
  spaDetail: FAKE_DATA.spaDetail || {},
  dinnings: FAKE_DATA.dinnings || [],
  dinningDetail: FAKE_DATA.dinningDetail || {},
  experiences: FAKE_DATA.experiences || [],
  experienceDetail: FAKE_DATA.experienceDetail || {},
  events: FAKE_DATA.events,
  comments: FAKE_DATA.comments || [],
  galleries: FAKE_DATA.galleries || {},
  intro_section: {},
  section1: {},
  section2: {},
  section3: {},
  video_banner: {},
  subscribe_section: {},
  appReady: false,

  loadingPageDetail: false,
  updating: false,

  sendingEmail: false,
});

const getPages = (state = INITIAL_STATE) => {
  return { ...state };
};

const getPagesSuccess = (state = INITIAL_STATE, { payload }) => {
  return { ...state, ...payload };
};

const getPagesFailure = (state = INITIAL_STATE) => {
  return { ...state };
};

const getPageDetail = (state = INITIAL_STATE) => {
  return { ...state, loadingPageDetail: true };
};

const getPageDetailSuccess = (state = INITIAL_STATE, { payload }) => {
  return { ...state, ...payload, loadingPageDetail: false };
};

const getPageDetailFailure = (state = INITIAL_STATE) => {
  return { ...state, loadingPageDetail: false };
};

const updateData = (state = INITIAL_STATE) => {
  return { ...state, updating: true };
};

const updateDataSuccess = (state = INITIAL_STATE, { payload }) => {
  return { ...state, ...payload, updating: false };
};

const updateDataFailure = (state = INITIAL_STATE) => {
  return { ...state, updating: false };
};

const deleteData = (state = INITIAL_STATE) => {
  return { ...state, updating: true };
};

const deleteDataSuccess = (state = INITIAL_STATE, { payload }) => {
  return { ...state, ...payload, updating: false };
};

const deleteDataFailure = (state = INITIAL_STATE) => {
  return { ...state, updating: false };
};

const sendEmail = (state = INITIAL_STATE) => {
  return { ...state, sendingEmail: true };
};

const sendEmailSuccess = (state = INITIAL_STATE) => {
  return { ...state, sendingEmail: false };
};

const sendEmailFailure = (state = INITIAL_STATE) => {
  return { ...state, sendingEmail: false };
};

const uploadImageToAlbum = (state = INITIAL_STATE) => {
  return { ...state, updating: true };
};

const uploadImageToAlbumSuccess = (state = INITIAL_STATE, { payload }) => {
  return { ...state, ...payload, updating: false };
};

const uploadImageToAlbumFailure = (state = INITIAL_STATE) => {
  return { ...state, updating: false };
};

const deleteImageFromAlbum = (state = INITIAL_STATE) => {
  return { ...state, updating: true };
};

const deleteImageFromAlbumSuccess = (state = INITIAL_STATE, { payload }) => {
  return { ...state, ...payload, updating: false };
};

const deleteImageFromAlbumFailure = (state = INITIAL_STATE) => {
  return { ...state, updating: false };
};

export const AdminTypes = Types;

export const AdminReducer = createReducer(INITIAL_STATE, {
  [Types.GET_PAGES_DATA]: getPages,
  [Types.GET_PAGES_DATA_SUCCESS]: getPagesSuccess,
  [Types.GET_PAGES_DATA_FAILURE]: getPagesFailure,

  [Types.GET_PAGE_DETAIL]: getPageDetail,
  [Types.GET_PAGE_DETAIL_SUCCESS]: getPageDetailSuccess,
  [Types.GET_PAGE_DETAIL_FAILURE]: getPageDetailFailure,

  [Types.UPDATE_DATA]: updateData,
  [Types.UPDATE_DATA_SUCCESS]: updateDataSuccess,
  [Types.UPDATE_DATA_FAILURE]: updateDataFailure,

  [Types.DELETE_DATA]: deleteData,
  [Types.DELETE_DATA_SUCCESS]: deleteDataSuccess,
  [Types.DELETE_DATA_FAILURE]: deleteDataFailure,

  [Types.SEND_EMAIL]: sendEmail,
  [Types.SEND_EMAIL_SUCCESS]: sendEmailSuccess,
  [Types.SEND_EMAIL_FAILURE]: sendEmailFailure,

  [Types.UPLOAD_IMAGE_TO_ALBUM]: uploadImageToAlbum,
  [Types.UPLOAD_IMAGE_TO_ALBUM_SUCCESS]: uploadImageToAlbumSuccess,
  [Types.UPLOAD_IMAGE_TO_ALBUM_FAILURE]: uploadImageToAlbumFailure,

  [Types.DELETE_IMAGE_FROM_ALBUM]: deleteImageFromAlbum,
  [Types.DELETE_IMAGE_FROM_ALBUM_SUCCESS]: deleteImageFromAlbumSuccess,
  [Types.DELETE_IMAGE_FROM_ALBUM_FAILURE]: deleteImageFromAlbumFailure,
});

export const AdminActions = Creators;
